module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a3e613b3b210291eba8ac6fa067d3eba.png";